import type { AggResponseData } from '../types';

export const transformAggIsArchivedToLegacyGira = (data: AggResponseData): boolean =>
	data.jira.issueByKey?.isArchived || false;
